/**
 * bootprompt.js locale configuration
 * locale : Persian
 * author : Touhid Arastu
 */

import { addLocale } from "../bootprompt";

addLocale("fa", {
  OK: "قبول",
  CANCEL: "لغو",
  CONFIRM: "تایید",
});
